import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { FileArrowDown } from "@phosphor-icons/react";

export const BidMatrixDialog = ({ client, onClose }) => {
  const [vendors, setVendors] = useState(["", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!client) return;
    let active = true;
    setVendors(["", "", "", ""]);
    setLoading(true);
    api.get(`/reports/bid-matrix/${client.id}/vendors`)
      .then(({ data }) => active && setVendors([0, 1, 2, 3].map((i) => data.vendors[i] || "")))
      .catch(() => active && toast.error("Could not load past providers"))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [client]);

  const download = async () => {
    setSaving(true);
    try {
      const { data } = await api.post(`/reports/bid-matrix/${client.id}`, { vendors }, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `2027 Bid Matrix - ${client.name || "client"}.xlsx`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
      onClose();
    } catch { toast.error("Failed to download bid matrix"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={!!client} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="rounded-none max-w-md" data-testid="bid-matrix-dialog">
        <DialogHeader>
          <DialogTitle className="text-[#002FA7]">2027 Bid Matrix</DialogTitle>
          <DialogDescription>{client?.name} — vendor names are suggested from past Form 471 providers. Edit as needed.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {vendors.map((v, i) => (
            <Input key={i} data-testid={`bid-matrix-vendor-${i + 1}`} value={v} disabled={loading}
              placeholder={loading ? "Loading…" : `Vendor ${i + 1}`} className="rounded-none"
              onChange={(e) => setVendors((p) => p.map((x, j) => (j === i ? e.target.value : x)))} />
          ))}
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <button data-testid="bid-matrix-cancel-btn" onClick={onClose} className="text-xs border border-[#1A1D20] rounded-none font-medium px-3 py-1.5 hover:bg-[#F8F9FA]">Cancel</button>
          <button data-testid="bid-matrix-download-btn" onClick={download} disabled={saving || loading} className="text-xs bg-[#002FA7] text-white hover:bg-[#002480] disabled:opacity-50 rounded-none font-medium px-3 py-1.5 flex items-center gap-1.5">
            <FileArrowDown size={12} weight="bold" /> {saving ? "Preparing…" : "Download"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
